import { createSerializationAdapter, SearchParamError } from '@tanstack/react-router';
import { deserialize, serialize } from 'superjson';

export const searchParamErrorAdapter = createSerializationAdapter({
  key: 'search-param-error-adapter',
  test: (value: unknown) => value instanceof SearchParamError,
  toSerializable: value => {
    return serialize(value.cause);
  },
  fromSerializable: value => {
    return new SearchParamError('', { cause: deserialize(value) });
  }
});
